import React from 'react'
import Picture from '../../components/Picture/Picture'
import './HomePage.css'

const Homepage = () => {
  return (
    <div className='homepage'>
    <Picture/>
    </div>
  )
}

export default Homepage